import type { SyntheticEvent } from 'react'
import Close from '@mui/icons-material/Close'
import Button from '@mui/material/Button'
import IconButton from '@mui/material/IconButton'
import Snackbar from '@mui/material/Snackbar'

interface BannerProps {
    autoHideDuration?: number | null
    id: string
    isOpen: boolean
    message: string
    onRetry?: () => void | Promise<void>
    onClose: () => void
}

export const Banner = ({ autoHideDuration, id, isOpen, message, onRetry, onClose }: BannerProps) => {
    const handleClose = (event: SyntheticEvent | Event, reason?: string) => {
        if (reason === 'clickaway') return
        onClose()
    }
    return (
        <Snackbar
            key={id}
            open={isOpen}
            message={message}
            autoHideDuration={autoHideDuration}
            onClose={handleClose}
            anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
            action={
                <>
                    {onRetry ? (
                        <Button color="secondary" onClick={() => void onRetry()}>
                            Retry
                        </Button>
                    ) : null}
                    <IconButton color="inherit" onClick={handleClose}>
                        <Close />
                    </IconButton>
                </>
            }
        />
    )
}
